const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const MortgageRequestMovingExpensesSuccess = require('components/mortgageRequest/mortgageRequestMovingExpenses/mortgageRequestMovingExpensesSuccess/mortgageRequestMovingExpensesSuccess');

// @actions
const mortgateRequestMovingExpensesAction = require('actions/mortgageRequest/mortgageRequestMovingExpenses');

class MortgageRequestMovingExpensesSuccessView extends React.Component {
    constructor(props) {
        super(props);

        this.handleRequestMontlyFee = this.handleRequestMontlyFee.bind(this);
        this.handleCancelMovingExpensesCurrentOffer = this.handleCancelMovingExpensesCurrentOffer.bind(this);
    }

    handleCancelMovingExpensesCurrentOffer() {
        this.props.cancelMovingExpensesCurrentOffer(this.props.history);
    }

    handleRequestMontlyFee(movingExpenses) {
        this.props.requestMonthlyFee(movingExpenses);
    }

    render() {
        const { mortgageRequestMortgageData, mortgageRequestMovingExpensesData, immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestMovingExpensesSuccessView-mortgageRequestMovingExpensesSuccessView_breadcrumb'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        let content = '';

        if (mortgageRequestMortgageData.get('isFetching') || !mortgageRequestMortgageData.get('req')) {
            content = <LoadingSection />;
        } else {
            content = (
                <MortgageRequestMovingExpensesSuccess
                    mortgageRequestMortgageData={mortgageRequestMortgageData}
                    mortgageRequestMovingExpensesData={mortgageRequestMovingExpensesData}
                    onRequestMontlyFee={this.handleRequestMontlyFee}
                    onCancelMovingExpensesCurrentOffer={this.handleCancelMovingExpensesCurrentOffer}
                />
            );
        }

        return (
            <div className="grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestMovingExpensesSuccessView-mortgageRequestMovingExpensesSuccessView_title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-8 col-xs-offset-2">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestMovingExpensesSuccessView.propTypes = {
    mortgageRequestMortgageData: PropTypes.object,
    mortgageRequestMovingExpensesData: PropTypes.object,
    requestMortgageData: PropTypes.func.isRequired,
    requestMonthlyFee: PropTypes.func.isRequired,
    cancelMovingExpensesCurrentOffer: PropTypes.func.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
}

module.exports.MortgageRequestMovingExpensesSuccessView = withRouter(connect(
    state => ({
        mortgageRequestMortgageData: state.mortgageRequestMortgageData,
        mortgageRequestMovingExpensesData: state.mortgageRequestMovingExpenses,
        immGlobalPosition: state.globalPosition,
    }), {
    requestMonthlyFee: mortgateRequestMovingExpensesAction.requestMonthlyFee,
    cancelMovingExpensesCurrentOffer: mortgateRequestMovingExpensesAction.cancelMovingExpensesCurrentOffer
}
)(MortgageRequestMovingExpensesSuccessView));
